<template>
    <div class="shop-tuiguang">
        <!-- 页面容器 -->
        <div class="container">

            <!-- 搜索区域 -->
            <div class="search-area">
                <div class="search-box">
                    <input type="text" placeholder="请输入关键词" class="search-input" v-model="keywords"
                        @keyup.enter="getShangjiaTuiGuang">
                    <button class="search-btn" @click="getShangjiaTuiGuang">
                        <img src="../../assets/images/13.png" alt="">
                    </button>
                </div>
                <el-button type="primary" class="promote-button" @click="goTuiguang">我要推广</el-button>
            </div>

            <!-- 推广列表 -->
            <div class="promote-list">
                <div v-for="(item, index) in promoteList" :key="index" class="promote-item" @click="goTuiguangDetails(item)">
                    <div v-if="item.is_top == 1" class="promote-arrow">
                        <img src="../../assets/images/24.png" alt="">
                    </div>
                    <div class="promote-title">{{ item.title }}</div>
                    <div class="promote-date">{{ item.create_time }}</div>
                </div>
            </div>


            <!-- 分页控件 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShopTuiguang",
    data() {
        return {
            searchKeyword: "",
            promoteList: [],

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,
            keywords: '',
            cityCode: ''
        };
    },
    mounted() {
        this.cityCode = this.$store.state.cityCode[1]
        this.getShangjiaTuiGuang();
    },
    computed: {
        // 通过getter获取cityCode
        // cityCode() {
        //     return this.$store.getters.getCityCode[1];
        // }
    },
    watch: {
        cityCode(newVal, oldVal) {
            this.getShangjiaTuiGuang()
        }
    },

    methods: {
        goTuiguang() {
            this.$router.push({
                path: '/FabuTuiguang',
            })
        },
        // 点击推广详情
        goTuiguangDetails(item) {
            this.$router.push({
                path: '/TuiguangDetails',
                query: {
                    aid: item.aid,
                }
            })
        },
        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getShangjiaTuiGuang();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getShangjiaTuiGuang();
        },

        // 获取推广列表数据
        getShangjiaTuiGuang() {
            let data = {
                keywords: this.keywords,
                region_code: this.cityCode,
                page: this.currentPage,
                list_rows: this.pageSize,
            }
            this.$api.getShangjiaTuiGuang(data).then(res => {
                let list = res.data;
                this.promoteList = list;
                this.totalOrders = res.total;

            }).catch(err => {
                this.$message.error(err);
            })
        },
    },
};
</script>

<style scoped>
.shop-tuiguang {
    background-color: #f5f5f5;
    min-height: calc(100vh - 120px);
    padding: 20px 0;
}

.container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.content-title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
}

.search-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.search-input {
    width: 400px;
}

.promote-button {
    background-color: #47A01A;
    border-color: #47A01A;
}

.promote-list {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.promote-item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e0e0e0;
    transition: all 0.3s;
}

.promote-item:last-child {
    border-bottom: none;
}

.promote-item:hover {
    background-color: #fafafa;
}

.promote-arrow {
    width: 20px;
    color: #286CED;
    margin-right: 10px;
}

.promote-arrow.empty {
    visibility: hidden;
}

.promote-arrow img {
    width: 14px;
    height: 14px;
}

.promote-title {
    flex: 1;
    color: #333333;
    font-size: 14px;
    text-align: left;

}

.promote-date {
    color: #909399;
    font-size: 14px;
}

/* 搜索框样式 */
.search-box {
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
}

.search-input {
    width: 200px;
    padding: 8px 15px;
    /* border: 1px solid #e0e0e0; */
    border: none;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
}

.search-input:focus {
    border-color: #286CED;
}

.search-btn {
    padding: 8px 12px;
    background-color: #ffffff;
    color: #999;
    border: 1px solid #e0e0e0;
    border-left: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    /* font-size: 16px; */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    border: none;
}

/* .search-btn:hover {
    color: #286CED;
    border-color: #286CED;
} */
.search-btn img {
    width: 16px;
    height: 16px;
    margin-right: 12px;
}

.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

.baojia_btn {
    background: #FFFFFF;
    border: 1px solid #2563E5;
    color: #286CED;

}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        width: 100%;
        padding: 0 20px;
    }
}

@media (max-width: 768px) {
    .search-area {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
    }

    .search-input {
        width: 100%;
    }
}
</style>